import { LiteratureReviewPlan } from '@core/domain/models/literature-review-plan.model'
import { Review } from '@core/domain/models/review.model'
import { ReviewPreset } from '@core/domain/types/review-preset.type'
import { generatePmsSearchQuery } from './generators/pms'
import { generateMedicalBackgroundSearchQuery } from './generators/medicalBackground'
import { generateNotifiedBodySearchQuery } from './generators/notifiedBody'

const SUPPORTED_PRESETS = [
  ReviewPreset.DEVICE_SPECIFIC_SEARCH,
  ReviewPreset.MEDICAL_BACKGROUND,
  ReviewPreset.NOTIFIED_BODY,
] as const

type SupportedPreset = (typeof SUPPORTED_PRESETS)[number]

const isValidPlan = (
  plan: LiteratureReviewPlan | undefined,
): plan is LiteratureReviewPlan & { preset: SupportedPreset } =>
  !!plan && SUPPORTED_PRESETS.includes(plan.preset as SupportedPreset)

export function generateSearchQuery(
  importSourceId: string,
  review: Review,
): string {
  const plan = review.plan
  if (!isValidPlan(plan)) return ''

  if (plan.preset === ReviewPreset.DEVICE_SPECIFIC_SEARCH) {
    return generatePmsSearchQuery({ importSourceId, plan })
  }
  if (plan.preset === ReviewPreset.MEDICAL_BACKGROUND) {
    return generateMedicalBackgroundSearchQuery(importSourceId, plan)
  }
  if (plan.preset === ReviewPreset.NOTIFIED_BODY) {
    return generateNotifiedBodySearchQuery(importSourceId, plan)
  }
  return ''
}
